<template>
  <div class="workspace">
    <TopHeader />
    <Navi />

    <div class="wrapper">
      <router-view />
    </div>
  </div>
</template>

<script>
import Navi from "@/components/Navi";
import TopHeader from "@/components/Header";
import FluidBend from "@/components/FluidBend";

export default {
  name: "AdminLayout",
  components: { Navi, TopHeader },
  mounted() {
    this.$store.dispatch("loadIntent");
    this.$store.dispatch("senStore/loadSenIntent");
    this.$store.state.mode = "form";

    this.$store.state.questionmeta.owner = this.$cookies.get("user_id");
  },
};
</script>


<style lang="scss" scoped>
</style>